import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {GeolocationIofesign} from '../../../user/model/GeolocationIofesign';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PersonService} from '../../../user/service/person.service';
import {TranslateService} from '@ngx-translate/core';
import {NgxImageCompressService} from 'ngx-image-compress';
import {InformType} from '../../../global/util/enum/InformType';
import {Constant} from '../../../global/util/Constant';
import {StringUtil} from '../../../global/util/StringUtil';
import {Dialog} from '../../../global/util/Dialog';
import {UnitMeasure} from '../../../global/util/UnitMeasure';
import {ActivatedRoute, Router} from '@angular/router';
import {Document} from '../../../user/model/Document';
import {StamprubrictemporalList} from '../../../user/model/StamprubrictemporalList';
import {AlertMessage} from '../../../global/util/AlertMessage';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {SafeUrl} from '@angular/platform-browser';
import {DocumentUtil} from '../../../global/util/DocumentUtil';
import {Stampdatetime} from '../../../user/model/Stampdatetime';
import {SignService} from '../../../user/service/sign.service';
import {DocumentService} from '../../../user/service/document.service';
import {GeolocationService} from '../../../user/service/geolocation.service';
import {PublicService} from '../../../user/service/public.service';

@Component({
    selector: 'app-add-or-draw-rubric',
    templateUrl: './add-or-draw-rubric.component.html',
    styleUrls: ['./add-or-draw-rubric.component.css']
})
export class AddOrDrawRubricComponent implements OnInit, AfterViewInit {
    public signatureForm: any;
    @Output() signatureSaved = new EventEmitter();
    // @ViewChild('canvas', {static: true}) canvas: ElementRef<HTMLCanvasElement>;
    @ViewChild('canvas', {static: false}) canvas!: ElementRef<HTMLCanvasElement>;
    // context: CanvasRenderingContext2D;
    // sigPadElement: HTMLCanvasElement;
    public drawing = false;
    @Output() signatureChange: EventEmitter<string> = new EventEmitter<string>();
    private geolocation: GeolocationIofesign;
    private longitude = null;
    private latitude = null;
    private accuracy = null;
    private context!: CanvasRenderingContext2D;
    private isDrawing = false;
    public isInvited = true;
    public personId?: number;
    public uuid?: string;
    private signatureImg?: string;
    private sigPadElement: HTMLCanvasElement;
    public signaturePadForm: FormGroup;
    public lineWitdh = 5;
    public strokeColor = 'black';
    public rubricSrc: string | ArrayBuffer;
    public previewRubricWidth = '350';
    public isReady2Save = false;
    public isDrawComplete = false;
    public isDrawTabOption = false;
    private hashIdentifier: any;
    public document: any;
    public person: any;
    public isPresentRubric = false;
    public returnBack = true;
    public messageAlert: any;
    public showError: boolean;
    public hasConfigBalance: boolean;
    public hasMultipleAttachments = false;
    public positionRubrics: any[] = [];
    public signCompleted = false;
    public loading: boolean;
    public reasonForSigning: string;
    public selectedSignatureDescriptions: any[] = [];
    public loadingSign: boolean;
    public signatureDescriptions: any[] = [];
    public alertType = AlertMessage.DANGER;
    private addedRubric: boolean;
    public isFirstAddRubric = true;

    constructor(private formBuilder: FormBuilder,
                private personService: PersonService,
                private translate: TranslateService,
                private route: Router,
                private signService: SignService,
                private documentService: DocumentService,
                private publicService: PublicService,
                private geolocationService: GeolocationService,
                private imageCompressService: NgxImageCompressService,
                private activatedRoute: ActivatedRoute) {
        this.createForm();
        this.receiveParams();
    }

    ngOnInit(): void {
        if (!this.document) {
            this.back();
        } else {
            this.loadDocumentData(this.hashIdentifier);
        }
        this.loadRubricSrc(this.document);
        this.personId = this.person.id;
        this.hasConfigBalance = this.document._more.hasConfigBalance;
        this.hasMultipleAttachments = this.document._more.resources.length > 1;
        this.getCurrentPositions();
        if (TypeSignature.DIGITAL === this.document._more.typeSignature && this.document._more.hasRubricSettings) {
            if (this.document._more.base64RubricFile === null || this.document._more.base64RubricFile === undefined) {
                this.addedRubric = false;
            } else {
                this.addedRubric = true;
            }
            if (this.document._more.dragRubric) {
                this.getListSignatureDescriptionFromDB();
            }
        }
    }

    public receiveParams() {
        this.activatedRoute.params.subscribe(params => {
            this.hashIdentifier = params.hashIdentifier;
            this.personId = +params.personId;
        });
        this.document = history.state.document;
        this.person = history.state.person;
    }

    public createForm() {
        this.signaturePadForm = this.formBuilder.group({
            lineWitdh: [''],
            strokeColor: [''],
            rubricFilename2Show: [''],
            rubricFileBase64: [''],
            rubricFilename: [''],
            extensionFilename: [''],
        });
    }

    private loadDocumentData(hashIdentifier: string) {
        this.loading = true;
        const urlDocument = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/hashIdentifier/', hashIdentifier, '/documents');
        this.personService.get(urlDocument).subscribe((next: Document) => {
            this.loading = false;
            this.document = next;
        }, error => {
            this.loading = false;
            this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/sign']).then();

        });
    }

    /**
     * Captura cuando el usuario comienza a dibujar su rubrica
     */
    onMouseDown(e: any): void {
        // The mouse button is clicked, which means the start of drawing the signature
        this.isDrawing = true;
        this.isDrawComplete = true;
        const coords = this.relativeCoords(e);
        this.context.moveTo(coords.x, coords.y);
    }

    /**
     * Acción que captura cuando el usuario suelta mouse o touchPad
     */
    @HostListener('document:mouseup', ['$event'])
    onMouseUp(): void {
        // The mouse button is released, so this means the end of drawing the signature
        this.isDrawing = false;
    }

    /**
     * Limpia el dibujo de la rubrica
     */
    clearSignature(): void {
        this.isDrawComplete = false;
        this.signatureImg = undefined;
        this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
        this.context.beginPath();
    }

    /**
     * Guarda la imagen subica por usuario.
     */
    saveSignature(): void {
        this.showError = false;
        this.isFirstAddRubric = false;
        this.loading = true;
        if (this.isInvited) {
            this.signatureImg = this.sigPadElement.toDataURL('image/png');
            this.CompressUpdateRubricInvited();
        } else {
            this.compressUpdateRubric();
        }
    }

    /**
     * Guarda la imagen dibujada por el usuario.
     */
    saveDrawSignature(): void {
        this.showError = false;
        this.isFirstAddRubric = false;
        this.signatureImg = this.sigPadElement.toDataURL('image/png');
        if (this.isInvited) {
            this.updateDrawRubricInvited();
        } else {
            this.updateDrawRubric();
        }
    }

    /**
     * Actualiza las coordenadas del dibujo de rubrica realizado por el cliente.
     * @param event
     * @private
     */
    private relativeCoords(event: any): { x: number, y: number } {
        const bounds = event.target.getBoundingClientRect();
        const cords = {
            clientX: event.clientX || event.changedTouches[0].clientX,
            clientY: event.clientY || event.changedTouches[0].clientY
        };
        const x = cords.clientX - bounds.left;
        const y = cords.clientY - bounds.top;
        return {x, y};
    }

    /**
     * Lee la imagen subida por el usuario y la muestra.
     * @param event
     */
    public readSelectedRubric(event: any): void {
        const testFile = event.target.files[0];
        if (testFile.name.endsWith('.png') || testFile.name.endsWith('.jpg') || testFile.name.endsWith('.jpeg')
            || testFile.name.endsWith('.PNG') || testFile.name.endsWith('.JPG') || testFile.name.endsWith('.JPEG')) {
            if (event.target.files && event.target.files[0]) {
                const file = event.target.files[0];
                const reader = new FileReader();
                reader.onload = () => this.rubricSrc = reader.result;
                reader.readAsDataURL(file);
            }
        }
    }

    public changeStatus(event: any) {
        const testFile = event[Constant.ZERO_INDEX];
        if (testFile.name.endsWith('.png') || testFile.name.endsWith('.jpg') || testFile.name.endsWith('.jpeg')
            || testFile.name.endsWith('.PNG') || testFile.name.endsWith('.JPG') || testFile.name.endsWith('.JPEG')) {
            this.signaturePadForm.patchValue({
                rubricFileBase64: testFile.base64,
                rubricFilename: testFile.name,
                extensionFilename: testFile.type.split('/').pop(),
                rubricFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
            });
            this.updateValueAndValidityRubricFields();
        } else {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.RUBRIC-UPDATE'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
            return;
        }
    }

    private updateValueAndValidityRubricFields() {
        this.signaturePadForm.get('rubricFileBase64').updateValueAndValidity();
        this.signaturePadForm.get('rubricFilename').updateValueAndValidity();
        this.signaturePadForm.get('rubricFilename2Show').updateValueAndValidity();
        this.isReady2Save = true;
    }

    public isInvalidControl(ctrlName: string) {
        return this.signaturePadForm.get(ctrlName).invalid && this.signaturePadForm.get(ctrlName).touched;
    }

    get defaultRubricSrc(): string | ArrayBuffer {
        return this.rubricSrc || this.placeHoldItRubric;
    }

    get placeHoldItRubric(): string {
        this.isFirstAddRubric = true;
        return Constant.DEFAULT_IMAGE;
    }

    get styleDimensionsRubric(): string {
        return 'width: ' + this.previewRubricWidth + 'px; height: 210px';
    }

    /**
     * Envia la imagen dibujada al servidor para ser guardada.
     */
    public updateDrawRubric(): void {
        this.showError = false;
        const rubricFileBase64: string = this.signatureImg;
        const rubricFilename = 'drawImage.png';
        const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/rubric');
        this.personService.updateRubric(url, rubricFileBase64, rubricFilename).subscribe(() => {
            this.showError = true;
            this.showMessage(this.isFirstAddRubric ? this.translate.instant('THE-RUBRIC-ADD-SUCCESSFULLY') : this.translate.instant('THE-RUBRIC-UPDATED-SUCCESSFULLY'), AlertMessage.SUCCESS);
            LocalStorage.setItem('rubricFile', this.signatureImg);
            this.isPresentRubric = true;
            this.isFirstAddRubric = false;
        }, () => {
            this.showError = true;
            this.showMessage(this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'), AlertMessage.DANGER);
        });
    }

    /**
     * Envia la imagen dibujada al servidor para ser guardada.
     */
    public updateDrawRubricInvited(): void {
        this.showError = false;
        this.loading = true;
        const rubricFileBase64: string = this.signatureImg;
        const rubricFilename = 'drawImage.png';
        const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/rubric?uuid=', this.document._more.uuid);
        this.personService.updateRubric(url, rubricFileBase64, rubricFilename).subscribe(() => {
            LocalStorage.setItem('rubricFile', this.signatureImg);
            this.loading = false;
            this.isPresentRubric = true;
            this.showError = true;
            this.rubricSrc = this.signatureImg;
            this.document._more.rubricFileExtension = 'png';
            this.document._more.base64RubricFile = rubricFileBase64;
            this.loadDocumentData(this.hashIdentifier);
            this.showMessage(this.translate.instant('MESSAGE.THE-RUBRIC-UPDATED-SUCCESSFULLY'), AlertMessage.SUCCESS);
        }, () => {
            this.showError = true;
            this.loading = false;
            this.showMessage(this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'), AlertMessage.DANGER);
        });
    }

    /**
     * Vrificamos el tamaño de la imagen seleccionada, si es mayor a 1 MB se comprime la imagen reduciendo en peso en un 70%
     */
    public compressUpdateRubric(): void {
        const rubricFileBase64: string = this.signaturePadForm.get('rubricFileBase64').value;
        const rubricFilename: string = this.signaturePadForm.get('rubricFilename').value;
        const sizeOfOriginalImage = this.imageCompressService.byteCount(rubricFileBase64) / (1024 * 1024);
        if (sizeOfOriginalImage >= UnitMeasure.ONE_MB && rubricFileBase64 !== '') {
            // tslint:disable-next-line:one-variable-per-declaration
            const orientation = -1, radio = 40, quality = 40;
            this.imageCompressService.compressFile(rubricFileBase64, orientation, radio, quality).then(resultBase64Compress => {
                console.log('Size in bytes is now:', this.imageCompressService.byteCount(resultBase64Compress) / (1024 * 1024));
                this.updateRubric(resultBase64Compress, rubricFilename);
            });
        } else {
            this.updateRubric(rubricFileBase64, rubricFilename);
        }
    }

    /**
     * Vrificamos el tamaño de la imagen seleccionada, si es mayor a 1 MB se comprime la imagen reduciendo en peso en un 70%
     */
    public CompressUpdateRubricInvited(): void {
        const rubricFileBase64: string = this.signaturePadForm.get('rubricFileBase64').value;
        const rubricFilename: string = this.signaturePadForm.get('rubricFilename').value;
        const rubricFileExtension: string = this.signaturePadForm.get('extensionFilename').value;
        const sizeOfOriginalImage = this.imageCompressService.byteCount(rubricFileBase64) / (1024 * 1024);
        if (sizeOfOriginalImage >= UnitMeasure.ONE_MB && rubricFileBase64 !== '') {
            // tslint:disable-next-line:one-variable-per-declaration
            const orientation = -1, radio = 40, quality = 40;
            this.imageCompressService.compressFile(rubricFileBase64, orientation, radio, quality).then(resultBase64Compress => {
                this.updateRubricInvited(resultBase64Compress, rubricFilename, rubricFileExtension);
            });
        } else {
            this.updateRubricInvited(rubricFileBase64, rubricFilename, rubricFileExtension);
        }
    }

    change(signatureDrawing: boolean) {
        this.isDrawTabOption = signatureDrawing;
        return this.isDrawTabOption;
    }

    /**
     * Envia la imagen cargada al servidor para ser guardada.
     * @param resultBase64Compress
     * @param rubricFilename
     * @private
     */
    private updateRubric(resultBase64Compress: string, rubricFilename: string) {
        this.showError = false;
        const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/rubric');
        this.personService.updateRubric(url, resultBase64Compress, rubricFilename).subscribe(() => {
            LocalStorage.setItem('rubricFile', this.rubricSrc);
            this.isPresentRubric = true;
            this.showError = true;
            this.showMessage(this.isFirstAddRubric ? this.translate.instant('MESSAGE.THE-RUBRIC-ADD-SUCCESSFULLY') : this.translate.instant('MESSAGE.THE-RUBRIC-UPDATED-SUCCESSFULLY'), AlertMessage.SUCCESS);
            this.loading = false;
            this.isFirstAddRubric = false;
        }, error => {
            this.isPresentRubric = true;
            this.showError = true;
            this.loading = false;
            this.showMessage(error.error.message, AlertMessage.DANGER);
        });
    }

    /**
     * Envia la imagen cargada al servidor para ser guardada.
     * @param rubricFileBase64
     * @param rubricFilename
     * @param rubricFileExtension
     * @private
     */
    private updateRubricInvited(rubricFileBase64: string, rubricFilename: string, rubricFileExtension: string) {
        this.showError = false;
        const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/rubric?uuid=', this.document._more.uuid);
        this.personService.updateRubric(url, rubricFileBase64, rubricFilename).subscribe(() => {
            // Dialog.show(InformType.Success, this.translate.instant('TITLE.RUBRIC-UPDATE'));
            LocalStorage.setItem('rubricFileExtension', rubricFileExtension);
            LocalStorage.setItem('base64RubricFile', rubricFileBase64);
            LocalStorage.setItem('rubricFile', this.rubricSrc);
            this.document._more.rubricFileExtension = rubricFileExtension;
            this.document._more.base64RubricFile = rubricFileBase64.split(',')[1];
            this.showError = true;
            this.showMessage(this.isFirstAddRubric ? this.translate.instant('MESSAGE.THE-RUBRIC-ADD-SUCCESSFULLY') : this.translate.instant('MESSAGE.THE-RUBRIC-UPDATED-SUCCESSFULLY'), AlertMessage.SUCCESS);
            this.isPresentRubric = true;
            this.isFirstAddRubric = false;
            this.loading = false;
        }, error => {
            this.showError = true;
            this.loading = false;
            this.isPresentRubric = false;
            this.isFirstAddRubric = false;
            this.showMessage(error.error.message, AlertMessage.DANGER);
        });
    }


    startDrawing(event: any) {
        event.preventDefault();
        const coordinates = this.getCoordinates(event);
        this.isDrawing = true;
        this.isDrawComplete = true;
        this.context.lineWidth = this.lineWitdh;
        this.context.strokeStyle = this.strokeColor;
        this.context.stroke();
        this.context.beginPath();
        this.context.moveTo(coordinates.x, coordinates.y);
    }

    draw(event: any) {
        event.preventDefault();
        if (!this.isDrawing) {
            return;
        }
        const coordinates = this.getCoordinates(event);
        this.context.lineTo(coordinates.x, coordinates.y);
        this.context.stroke();
    }

    stopDrawing() {
        this.isDrawing = false;
        this.emitSignature();
    }

    private emitSignature() {
        const signatureDataUrl = this.canvas.nativeElement.toDataURL();
        this.signatureChange.emit(signatureDataUrl);
    }

    private getCoordinates(event: any) {
        const rect = this.canvas.nativeElement.getBoundingClientRect();
        // tslint:disable-next-line:one-variable-per-declaration
        let x: number, y: number;
        if (event instanceof MouseEvent) {
            x = event.clientX - rect.left;
            y = event.clientY - rect.top;
        } else if (event instanceof TouchEvent) {
            x = event.touches[0].clientX - rect.left;
            y = event.touches[0].clientY - rect.top;
        }

        return {x, y};
    }

    private setValueGeolocation(documentId: number, personId: number) {
        this.geolocation = new GeolocationIofesign();
        this.geolocation.latitude = String(this.latitude);
        this.geolocation.longitude = String(this.longitude);
        this.geolocation.accuracy = String(this.accuracy);
        this.geolocation.documentId = documentId;
        this.geolocation.personId = personId;
        this.geolocation.ip = LocalStorage.getIpAddress();
        return this.geolocation;
    }

    back() {
        this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/sign']).then();
    }

    private loadRubricSrc(document: Document) {
        if (document && document._more.rubricFileExtension && document._more.base64RubricFile) {
            this.isPresentRubric = true;
            this.isFirstAddRubric = false;
            this.rubricSrc = 'data:image/' + document._more.rubricFileExtension + ';base64,' + document._more.base64RubricFile;
        } else {
            this.isPresentRubric = false;
            this.isFirstAddRubric = true;
            this.rubricSrc = this.placeHoldItRubric;
        }
    }

    // navigateDocumentSigned() {
    //     this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/document-signed/'], {
    //         state: {
    //             document: this.document,
    //             person: this.person
    //         }
    //     }).then();
    // }

    get hasConfigRubric(): boolean {
        if (this.document !== undefined) {
            return this.document._more.hasRubricSettings;
        }
    }

    changeRubric() {
        this.isPresentRubric = false;
        this.showError = false;
        this.signaturePadForm.get('rubricFilename2Show').setValue('');
        this.updateValueAndValidityRubricFields();
        if (this.isDrawComplete) {
            this.clearSignature();
        }
        this.isReady2Save = false;
    }

    ngAfterViewInit(): void {
        if (this.canvas) {
            // tslint:disable-next-line:no-non-null-assertion
            this.context = this.canvas.nativeElement.getContext('2d')!;
            this.context.lineWidth = 2;
            this.context.lineCap = 'round';
            this.context.strokeStyle = '#000000';
            this.sigPadElement = this.canvas.nativeElement;

            // Touch event listeners
            this.canvas.nativeElement.addEventListener('touchstart', (event) => this.startDrawing(event), false);
            this.canvas.nativeElement.addEventListener('touchmove', (event) => this.draw(event), false);
            this.canvas.nativeElement.addEventListener('touchend', () => this.stopDrawing(), false);
        }
    }

    signDocument() {
        switch (this.document._more.typeSignature) {
            case TypeSignature.ELECTRONIC:
                this.signGrafic();
                break;
            case TypeSignature.DIGITAL:
                this.hasMultipleAttachments ? this.signBatchBy() : this.sign4TypeSignature();
                break;
            case TypeSignature.CLOUD:
                this.signCloud();
                break;
            case TypeSignature.REMOTE:
                this.signRemote();
                break;
        }
    }


    /*Firma gráfica con codígo de verificación o sin*/
    public signGrafic() {
        if (this.hasConfigRubric) {
            this.saveStamprubrictemporary();
        } else {
            this.signElectronically();
        }
    }

    public signRemote() {
        if (this.hasConfigRubric) {
            this.saveStamprubrictemporary();
        } else {
            this.navigateSigningCredential();
        }
    }

    public signCloud() {
        if (this.hasConfigRubric) {
            this.saveStamprubrictemporary();
        } else {
            this.sign4TypeSignature([this.document]);
        }
    }

    /*Firma gráfica con codígo de verificación o sin*/
    public signElectronically() {
        this.showError = false;
        if (this.hasConfigBalance) {
            this.verifyUserBalance();
        } else {
            this.sign4TypeSignature([this.document]);
        }
    }

    /**
     * Guarda las posiciones temporales de la rubrica.
     * @private
     */
    private saveStamprubrictemporary(documents?: Document[]) {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/stamprubrictemporary');
        const stamprubrictemporalinfo = new StamprubrictemporalList();
        this.getCurrentPositions();
        if (this.reasonForSigning === undefined) {
            this.reasonForSigning = '';
        }
        if (this.digitalSignature) {
            if (LocalStorage.getSelectedSignatureDescriptions()) {
                this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
            } else {
                this.selectedSignatureDescriptions = this.getListSignatureDescription();
            }
            const SelectedSignatureDescription = this.selectedSignatureDescriptions.filter(value => value.initialized === true);
            const docIdentifiers = StringUtil.concatIdentifiers(SelectedSignatureDescription);
            this.positionRubrics.forEach(value => value.signaturedescriptionIds = docIdentifiers);
        }
        stamprubrictemporalinfo.stamprubrictemporals = this.positionRubrics;
        this.signService.save(url, stamprubrictemporalinfo).subscribe(() => {
            this.loading = false;
            if (this.hasConfigBalance) {
                this.verifyUserBalance();
            } else {
                documents = documents !== undefined ? documents : [this.document];
                this.sign4TypeSignature(documents);
            }
        }, () => {
            this.loading = false;
            this.showMessage(this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'), AlertMessage.DANGER);
        });
    }

    /**
     * Verifica si el usuario tiene el saldo suficiente para realizar esta acción
     */
    public verifyUserBalance() {
        this.loading = true;
        const documents: Document[] = [this.document];
        const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/documents/verify/userbalance?uuid=', this.document._more.uuid);
        this.documentService.verifyUserBalanceOrDemoNotcer(url, documents).subscribe(() => {
            this.sign4TypeSignature(documents);
        }, error => {
            this.loading = false;
            this.showError = true;
            if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
                this.showMessage(error.error.message, AlertMessage.DANGER);
                return;
            }
            this.signCompleted = false;
            this.showError = true;
            this.showMessage(this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'), AlertMessage.DANGER);
        });
    }

    public sign4TypeSignature(documents?: Document[]) {
        switch (this.document._more.typeSignature) {
            case TypeSignature.DIGITAL:
                if (this.hasMultipleAttachments) {
                    const identifiers = String(this.document.id);
                    this.signService.getUUID(this.personId, identifiers).subscribe((next: any) => {
                        const fromUrl = Constant.ROOT_API_V1
                            .concat('/public/signs/batch/stream?uuid=')
                            .concat(next.uuid);
                        const rsignUrl = 'rsign:?batch_csv='.concat(fromUrl);
                        window.open(rsignUrl, '_self');

                        const checkStatusBatchUrl = Constant.ROOT_API_V1
                            .concat('/public/signs/batch/status')
                            .concat('?uuid=')
                            .concat(next.uuid)
                            .concat('&personId=')
                            .concat(String(this.personId));
                        this.loadingSign = true;
                        const interval = setInterval(() => {
                            this.documentService.get(checkStatusBatchUrl).subscribe((next2: any) => {
                                if (next2.completed === Constant.FINISHED) {
                                    this.signCompleted = true;
                                    this.saveGeolocation([this.document], this.personId, 'Firma digital');
                                    clearInterval(interval);
                                    this.loadingSign = false;
                                    this.loading = false;
                                    this.navigateDocumentSigned();
                                }
                            }, () => {
                                // Dialog.show(InformType.Danger, this.title);
                            });
                        }, 3000);
                    }, () => {
                        this.showError = true;
                        this.showMessage(this.translate.instant('MESSAGE.REGISTRATION-ALREADY-EXISTS-IN-THE-SYSTEM'));
                    });
                } else {
                    this.openRCDSignatureOne2One(this.document);
                    const urlOne2One = Constant.ROOT_API_V1.concat('/public/signs/one2one/status')
                        .concat('?personId=')
                        .concat(String(this.personId))
                        .concat('&documentId=')
                        .concat(String(this.document.id));
                    this.loading = true;
                    const interval = setInterval(() => {
                        this.documentService.get(urlOne2One).subscribe((next: any) => {
                            if (next.completed === Constant.FINISHED) {
                                clearInterval(interval);
                                this.signCompleted = true;
                                this.loading = false;
                                this.loadingSign = false;
                                this.saveGeolocation([this.document], this.personId, 'Firma digital');
                                this.navigateDocumentSigned();
                            }
                        }, () => {
                            this.showError = true;
                            this.showMessage(this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'));
                        });
                    }, 2000);
                }
                break;
            case TypeSignature.ELECTRONIC:
                this.signElectronic([this.document]);
                break;
            case TypeSignature.CLOUD:
                LocalStorage.getItem('termConditionAccepted') === 'true' ? this.navigateRequestOtpCode() : this.navigateTermsCondition();
                break;
            case TypeSignature.REMOTE:
                this.navigateSigningCredential();
                break;
        }
    }

    openRCDSignatureOne2One(document: Document): void {
        const rsignUrl = this.getUrlSign(document).toString();
        window.open(rsignUrl, '_self');
    }

    public getUrlSign(document: any): SafeUrl {
        if (this.hasMultipleAttachments) {
            return;
        }
        const urlFrom = DocumentUtil.buildUrlDownload(document, this.personId);
        const urlTo = DocumentUtil.buildUrlUpload(document, this.personId);
        // Si es que tiene configurado el estapando de fecha y hora, se enviará al componente RC para la firma.
        if (document._more.stampdatetime) {
            const stampdatetime: Stampdatetime = document._more.stampdatetime;
            return 'rsign:?from='
                .concat(urlFrom)
                .concat('&to=')
                .concat(urlTo)
                .concat('&vis_sig_x=')
                .concat(String(stampdatetime.positionX))
                .concat('&vis_sig_y=')
                .concat(String(stampdatetime.positionY))
                .concat('&vis_sig_width=')
                .concat(String(stampdatetime.widthContainer))
                .concat('&vis_sig_height=')
                .concat(String(stampdatetime.heightContainer))
                .concat('&vis_sig_text=')
                .concat(stampdatetime.description)
                .concat('&vis_sig_page=')
                .concat(String(stampdatetime.stampOn));
        }
            // Si es que tiene configurado el arrastre de rubrica, se enviará al componente RC para la firma y para insertar
        // la imagen en esta misma y agregar datos del certificado.
        else if (this.hasConfigDragRubric) {
            const description = this.getSignatureDescription();
            const stampOn = this.positionRubrics[0].page === 0 ? 1 : this.positionRubrics[0].page;
            return 'rsign:?from='
                .concat(urlFrom)
                .concat('&to=')
                .concat(urlTo)
                .concat('&vis_sig_x=')
                .concat(String(this.positionRubrics[0].positionX))
                .concat('&vis_sig_y=')
                .concat(String(this.positionRubrics[0].positionY))
                .concat('&vis_sig_width=')
                .concat(String(this.positionRubrics[0].positionXf))
                .concat('&vis_sig_height=')
                .concat(String(this.positionRubrics[0].positionYf))
                .concat('&vis_sig_text=')
                .concat(description)
                .concat('&vis_sig_page=')
                .concat(String(stampOn))
                .concat('&vis_sig_image=')
                .concat(String(Constant.ROOT_API_V1 + '/public/people/' + this.personId + '/rubrics'));
        }
        return 'rsign:?from='
            .concat(urlFrom)
            .concat('&to=')
            .concat(urlTo);
    }

    showMessage(message: any, alertType?: any) {
        this.messageAlert = message;
        if (alertType) {
            this.alertType = alertType;
        } else {
            this.alertType = AlertMessage.DANGER;
        }
    }

    private saveGeolocation(documents: Document[], personId: number, signatureType: string) {
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < documents.length; index++) {
            const date = new Date(Date.now());
            const documentId = documents[index].id;
            this.geolocation = this.setValueGeolocation(documentId, personId);
            this.geolocation.signatureType = signatureType;
            this.geolocation.longTime = Date.now().toString();
            this.geolocation.timeStamp = date.toString();
            this.geolocation.timeZone = this.getGMT(date);
            this.geolocation.identification = null;
            this.geolocationService.save(this.geolocation).subscribe(resp => {

            }, error => {
                this.showError = true;
                this.showMessage('El sistema no pudo guardar su ubicación.');
            });
        }
    }

    public getListSignatureDescription(): any {
        this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
        if (this.selectedSignatureDescriptions) {
            return this.selectedSignatureDescriptions;
        } else {
            return this.signatureDescriptions;
        }
    }

    public signElectronic(documents?: Document[]) {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/documents/sign?uuid=', this.document._more.uuid);
        this.documentService.signElectronically(url, documents).subscribe(() => {
            this.loading = false;
            this.signCompleted = true;
            this.saveGeolocation(documents, this.personId, 'Firma gráfica');
            this.isDocumentFinished(this.document.id);
            this.navigateNextScreen(this.hashIdentifier, this.personId, 'document-signed');
        }, error => {
            this.loading = false;
            if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
                this.showError = true;
                this.showMessage(error.error.message);
                return;
            }
            this.signCompleted = false;
            this.showError = true;
            this.showMessage(this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'));
        });
    }

    private isDocumentFinished(documentId: number) {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/public/verify/document/have-manifest-and-traceability/?documentId=').concat(String(documentId));
        if (this.signCompleted) {
            const interval = setInterval(() => {
                this.publicService.get(url).subscribe((next2: any) => {
                    if (next2.hasConfManifestAndTraceability) {
                        if (next2.documentIsReady) {
                            this.loading = false;
                            clearInterval(interval);
                        }
                    } else {
                        this.loading = false;
                        clearInterval(interval);
                    }
                });
            }, 500);
        }
        setTimeout(() => {
            this.loading = false;
        }, 5000);
    }

    public signBatchBy() {
        if (this.hasConfigDragRubric) {
            this.saveStamprubrictemporary();
        } else {
            if (this.hasConfigBalance) {
                this.verifyUserBalance();
            } else {
                this.sign4TypeSignature();
            }
        }
    }

    /**
     * Obtiene la descripcciones de firma digital para ser enviadas al componente de firma.
     */
    public getSignatureDescription(): string {
        this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
        if (this.selectedSignatureDescriptions) {
            this.signatureDescriptions = this.selectedSignatureDescriptions;
        }
        let value = '';
        for (const signatureDescription of this.signatureDescriptions) {
            if (signatureDescription.initialized) {
                value += ''
                    .concat(signatureDescription.description)
                    .concat('%0A');
            }
        }
        value = value.replace('<RUC>', this.person._more.enterpriseDocumentNumber);
        value = value.replace('<ENTERPRISE>', this.person._more.enterpriseName);
        // Se codificara el caracter especial '&' para evitar problemas con el componente de firma
        value = value.replace('&', '%26');
        return StringUtil.removeCharacter(value, 3);
    }

    /**
     * Obtiene la lista de las descripcciones disponibles para mostrar en la firma digital.
     */
    public getListSignatureDescriptionFromDB() {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/public/signaturedescription?uuid=', this.document._more.uuid)
            .concat('&personId=')
            .concat(String(this.personId));
        this.documentService.post(url).subscribe(value => {
            this.loading = false;
            this.signatureDescriptions = value;
        }, () => {
            this.loading = false;
            this.signCompleted = false;
            this.showMessage(this.translate.instant('MESSAGE.THE-REQUESTED-OPERATION-WAS-NOT-COMPLETED'), AlertMessage.DANGER);
        });
    }

    private getGMT(date: Date) {
        return date.toTimeString().split(' ')[1];
    }


    backPreview() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'viewer');
    }

    private navigateDocumentSigned() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'document-signed');
    }

    private navigateTermsCondition() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'terms-conditions');
    }

    private navigateRequestOtpCode() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'request-otp-code');
    }

    private navigateSigningCredential() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'signing-credential');
    }

    /**
     * Este método recibe paramatros para navegar entre pantallas.
     * @param hashIdentifier :
     * @param personId :
     * @param nameUrl :
     * @private
     */
    private navigateNextScreen(hashIdentifier: any, personId: any, nameUrl: any) {
        this.route.navigate(['document/' + hashIdentifier + '/people/' + personId + '/' + nameUrl + '/'], {
            state: {
                document: this.document,
                person: this.person
            }
        }).then();
    }

    goBack() {
        this.isPresentRubric = true;
        this.signaturePadForm.get('rubricFilename2Show').setValue('');
        this.loadRubricSrc(this.document);
        this.updateValueAndValidityRubricFields();
        if (this.isDrawComplete) {
            this.clearSignature();
        }
        this.isReady2Save = false;
    }

    private getCurrentPositions() {
        this.positionRubrics = LocalStorage.getPositionRubrics();
    }

    get hasConfigDragRubric(): boolean {
        return !this.isCloseStampingAndIsNotDigitalSignature && this.hasConfigRubric && this.hasDragRubric;
    }

    get isCloseStampingAndIsNotDigitalSignature(): boolean {
        if (this.document !== undefined) {
            return this.document.closedStamping && !this.digitalSignature && !this.isCloudSignature && !this.isRemoteSignature;
        }
    }

    get hasDragRubric(): boolean {
        return this.document._more.dragRubric;
    }

    get isRemoteSignature(): boolean {
        return TypeSignature.REMOTE === this.document._more.typeSignature;
    }

    get isCloudSignature(): boolean {
        return TypeSignature.CLOUD === this.document._more.typeSignature;
    }

    get digitalSignature(): boolean {
        return TypeSignature.DIGITAL === this.document._more.typeSignature;
    }
}
